/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_Updated_AtInputs */

const en_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated At`)
};

const fr_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis a jour le`)
};

const de_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert am`)
};

const it_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornato alle`)
};

const ru_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлено в`)
};

const es_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado en`)
};

const zh_cn2_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新于`)
};

const ja_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日時`)
};

const hi_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट किया गया`)
};

const pt_pt2_manual_qc_export_updated_at = /** @type {(inputs: Manual_Qc_Export_Updated_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado em`)
};

/**
* | output |
* | --- |
* | "Updated At" |
*
* @param {Manual_Qc_Export_Updated_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_updated_at = /** @type {((inputs?: Manual_Qc_Export_Updated_AtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_Updated_AtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_updated_at(inputs)
	if (locale === "de") return de_manual_qc_export_updated_at(inputs)
	if (locale === "it") return it_manual_qc_export_updated_at(inputs)
	if (locale === "ru") return ru_manual_qc_export_updated_at(inputs)
	if (locale === "es") return es_manual_qc_export_updated_at(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_updated_at(inputs)
	if (locale === "ja") return ja_manual_qc_export_updated_at(inputs)
	if (locale === "hi") return hi_manual_qc_export_updated_at(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_updated_at(inputs)
	return en_manual_qc_export_updated_at(inputs)
});